// NEBBIA product card interactions — wishlist heart, color swatches, and the
// quick-add "+" / sliding size row. Shared by the homepage product rail
// (sections/nebbia-product-rail.liquid) and the collection/search grid
// (sections/main-collection-product-grid.liquid, via
// snippets/nb-collection-card.liquid) so a fix only has to happen once.
//
// Uses event delegation on `document` instead of binding a listener to each
// card at page load. That matters here specifically because Shopify's native
// collection filtering (assets/facets.js) replaces the whole
// #ProductGridContainer's innerHTML whenever a filter or sort changes —
// per-card listeners bound up front would silently stop working on every
// freshly-filtered card. Delegated listeners keep working on whatever cards
// exist at the moment of the click, filtered or not.
(function () {
  var WISHLIST_KEY = 'nebbia:wishlist';

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function writeWishlist(ids) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids)); } catch (e) {}
  }
  function syncWishlistButton(btn) {
    var id = btn.getAttribute('data-product-id');
    var active = readWishlist().indexOf(id) > -1;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }
  function syncAllWishlistButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncWishlistButton);
  }
  syncAllWishlistButtons();

  // Re-sync heart state whenever the grid is replaced (facet filter/sort).
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && 'MutationObserver' in window) {
    new MutationObserver(syncAllWishlistButtons).observe(gridContainer, {
      childList: true,
      subtree: true,
    });
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  document.addEventListener('click', function (e) {
    var wishlistBtn = e.target.closest('[data-wishlist-toggle]');
    if (wishlistBtn) {
      e.preventDefault();
      var id = wishlistBtn.getAttribute('data-product-id');
      var wishlist = readWishlist();
      var idx = wishlist.indexOf(id);
      if (idx > -1) {
        wishlist.splice(idx, 1);
      } else {
        wishlist.push(id);
      }
      writeWishlist(wishlist);
      // keep every card for this product in sync (it can appear in more than one rail/grid)
      document
        .querySelectorAll('[data-wishlist-toggle][data-product-id="' + id + '"]')
        .forEach(syncWishlistButton);
      return;
    }

    var swatch = e.target.closest('[data-color-swatch]');
    if (swatch) {
      var group = swatch.closest('[data-color-swatches]');
      var card = swatch.closest('.nb-product-card');
      if (group && card) {
        var img = card.querySelector('.nb-product-card__img--primary');
        group.querySelectorAll('[data-color-swatch]').forEach(function (s) {
          s.classList.remove('nb-product-card__swatch--active');
          s.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('nb-product-card__swatch--active');
        swatch.setAttribute('aria-pressed', 'true');

        var imageUrl = swatch.getAttribute('data-color-image');
        if (img && imageUrl) img.src = imageUrl;

        var colorValue = swatch.getAttribute('data-color-value');
        card.querySelectorAll('[data-size-group]').forEach(function (sg) {
          sg.classList.toggle('is-hidden', sg.getAttribute('data-size-group') !== colorValue);
        });
      }
      return;
    }

    var toggle = e.target.closest('[data-quickadd-toggle]');
    if (toggle) {
      var card2 = toggle.closest('.nb-product-card');
      var wrap = card2 && card2.querySelector('[data-quickadd]');
      if (wrap) {
        var open = wrap.classList.toggle('is-open');
        toggle.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var sizeBtn = e.target.closest('[data-variant-id]');
    if (sizeBtn) {
      if (sizeBtn.disabled || sizeBtn.classList.contains('is-loading')) return;
      var wrap2 = sizeBtn.closest('[data-quickadd]');
      var msg = wrap2 && wrap2.querySelector('[data-quickadd-msg]');
      var originalText = sizeBtn.textContent;
      sizeBtn.classList.add('is-loading');
      if (msg) msg.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: sizeBtn.getAttribute('data-variant-id'), quantity: 1 }],
        }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          sizeBtn.classList.remove('is-loading');
          if (result.ok) {
            sizeBtn.textContent = 'Added';
            sizeBtn.classList.add('is-added');
            if (msg) msg.textContent = 'Added to your bag.';
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) { setCartCount(cart.item_count); })
              .catch(function () {});
          } else {
            sizeBtn.textContent = 'Sold out';
            sizeBtn.disabled = true;
            if (msg) {
              msg.textContent = (result.data && result.data.description) || 'Couldn’t add that to your bag.';
            }
          }
          setTimeout(function () {
            if (!sizeBtn.disabled) {
              sizeBtn.textContent = originalText;
              sizeBtn.classList.remove('is-added');
            }
          }, 1600);
        })
        .catch(function () {
          sizeBtn.classList.remove('is-loading');
          if (msg) msg.textContent = 'Something went wrong — try again.';
        });
    }
  });
})();